
define(
	'Code25.CaterpartsGlobal.Redirects'
	, [
		"Utils","Backbone","Profile.Model"
	]
	, function (
		Utils,Backbone,ProfileModel
	) {
		'use strict';
		return {
			mount: function mount(container) {

				if (SC.ENVIRONMENT.SCTouchpoint == "checkout") {
        
					if (ProfileModel.ProfileModel) {
					  ProfileModel = ProfileModel.ProfileModel;
					}
					var isLoggedIn = ProfileModel.getInstance().get('isLoggedIn') === 'T';
					if (isLoggedIn) {
			
					  var url_options = Utils.parseUrlOptions(window.location.search);
			
					  var touchpoints = (SC && SC.SESSION && SC.SESSION.touchpoints)
					  if (touchpoints) {
						if (url_options.origin != "checkout" && touchpoints[url_options.origin]) {
			
						  var url = touchpoints[url_options.origin];
						  if (url_options.origin_hash) {
							url = Utils.addParamsToUrl(url, { fragment: url_options.origin_hash });
						  }
						  window.location.href = url;
						}
					  }
					}
			
				  }


				var router= Backbone.Router.extend({
					initialize: function (options) {
						
					},
					routes: { ///advanced-parts-search/batteries_4/Q800103
						'need-help': 'needHelp',
						'advanced-parts-search/:category/:product': 'oldProduct',
						'advanced-parts-search/:product': 'oldProduct2',
						'Special-Offers/:product': 'special'
					},
					needHelp: function () {
						if(!SC.isPageGenerator()){
						if (ProfileModel.getInstance().get("isLoggedIn") === "F") {
							Backbone.history.navigate('/contact-us', { trigger: true });
						}else{
							window.location.href = SC.ENVIRONMENT.siteSettings.touchpoints.customercenter+"#cases";
						}
					}

					},
					oldProduct:function(category,product){
						if(!SC.isPageGenerator()){
						console.log("redirect 1: "+'/products/'+product+" "+document.location);
						Backbone.history.navigate('/products/'+product, { trigger: true });
						}
					},
					oldProduct2:function(product){
						if(!SC.isPageGenerator()){
						console.log("redirect 2: "+'/products/'+product+" "+document.location);
						Backbone.history.navigate('/products/'+product, { trigger: true });
						}
					},
					special:function(product){
						if(!SC.isPageGenerator()){
						console.log("redirect special: "+'/'+product+" "+document.location);
						Backbone.history.navigate('/'+product, { trigger: true });
						}
					}
				});
				return new router(container);

			}

		}

	});
